module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "register-doctor",
    staticStyle: {
      "padding": "3em 2.5em"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.translate.pages.plans.know_ours_plans))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.data.plans), function(plan, index) {
    return _c('div', {
      staticClass: "col-sm-4 "
    }, [_c('md-card', {
      staticStyle: {
        "padding-top": "3em",
        "padding-bottom": "3em"
      }
    }, [_c('md-card-header', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "#b0b5bf",
        "font-size": "18pt",
        "text-transform": "uppercase"
      },
      domProps: {
        "innerHTML": _vm._s(plan.name)
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#cbd0d6"
      }
    }, [_c('strong', {
      staticStyle: {
        "color": "#2c4760",
        "font-size": "2.5em"
      }
    }, [_vm._v(_vm._s(plan.price))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "1.5em"
      }
    }, [_c('sup', [_vm._v("CLP")]), _vm._v("/"), _c('sub', [_vm._v("mes")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
      staticStyle: {
        "border": "1px solid #959ea6",
        "opacity": "0.1"
      }
    })]), _vm._v(" "), _c('md-card-content', [_c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-center mt-plan-description",
      domProps: {
        "innerHTML": _vm._s(plan.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_c('br'), _vm._v(" "), (_vm.data.activePlan !== plan.id) ? _c('md-button', {
      staticClass: "md-raised md-primary",
      nativeOn: {
        "click": function($event) {
          _vm.changePlan(plan.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.translate.pages.plans.know_more))]) : _c('div', {
      staticStyle: {
        "height": "49px"
      }
    }, [_c('br')])], 1)])], 1)], 1)
  })), _vm._v(" "), _c('md-dialog', {
    ref: "dialog1",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-content', [_vm._v(_vm._s(_vm.alert.msg))]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('dialog1')
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-328dcd13"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/Plans.vue
// module id = 670
// module chunks = 1